import { BaseApi } from './base.api.js';

export class PartyInstanceApi extends BaseApi {
    constructor(client) {
        super(client, '/party-instances');
    }

    async addAssignment(id, assignment) {
        return this.client.post(`${this.basePath}/${id}/assignments`, assignment);
    }

    async removeAssignment(id, assignmentId) {
        return this.client.delete(`${this.basePath}/${id}/assignments/${assignmentId}`);
    }
}
